import { render, staticRenderFns } from "./FleetDashboard.vue?vue&type=template&id=82a54bea&scoped=true"
import script from "./FleetDashboard.vue?vue&type=script&lang=js"
export * from "./FleetDashboard.vue?vue&type=script&lang=js"
import style0 from "./FleetDashboard.vue?vue&type=style&index=0&id=82a54bea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a54bea",
  null
  
)

export default component.exports